import Axios from "axios";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    createPushSubscription: (context, data) => {
        return Axios.post((<any>window).App.routes.PushSubscription_CreatePushSubscription, data);
    },
    getPushSubscriptions: (context, data) => {
        return Axios.post((<any>window).App.routes.PushSubscription_GetPushSubscriptions, data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};